import { render, staticRenderFns } from "./ICMO.vue?vue&type=template&id=28b55438&scoped=true&"
import script from "./ICMO.vue?vue&type=script&lang=js&"
export * from "./ICMO.vue?vue&type=script&lang=js&"
import style0 from "./ICMO.vue?vue&type=style&index=0&id=28b55438&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b55438",
  null
  
)

export default component.exports